<template>
  <div class="app-container">
    <!-- 意向金售卖配置的日志单独成页，版式同「日志管理」：列表 → 查看详情（变更前 / 变更后） -->
    <template v-if="!current">
      <el-card class="box-card">
        <el-form :inline="true">
          <el-form-item label="操作用户："><el-input v-model="query.operatorName" placeholder="请输入操作用户" clearable size="small" /></el-form-item>
          <el-form-item label="修改时间："><el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" /></el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="search">搜索</el-button>
            <el-button type="info" plain size="mini" @click="reset">重置</el-button>
            <el-button type="info" plain size="mini" @click="back">返回上一页</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card mt10">
        <el-alert v-if="error" :title="error" type="error" :closable="false" class="mb10" />
        <el-table v-loading="loading" :data="pageRows">
          <el-table-column label="操作用户" prop="operatorName" align="center" />
          <el-table-column label="访问模块" align="center">意向金售卖配置</el-table-column>
          <el-table-column label="被操作对象" align="center"><template slot-scope="{row}">{{ action(row.action, row.targetType) }}</template></el-table-column>
          <el-table-column label="修改时间" align="center" width="200"><template slot-scope="{row}">{{ time(row.occurredAt) }}</template></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="160"><template slot-scope="{row}"><el-button type="text" @click="current = row">查看详情</el-button></template></el-table-column>
        </el-table>
        <pagination v-show="filtered.length > 0" :total="filtered.length" :pageNo.sync="pageNo" :pageSize.sync="pageSize" />
      </el-card>
    </template>
    <el-card v-else>
      <div class="back-box"><div @click="current = null"><img src="../../../assets/back.png" alt=""><span>返回</span></div></div>
      <div class="log-oppea-box">
        <div class="item">操作用户：{{ current.operatorName || '-' }}</div>
        <div class="item">被操作对象：{{ action(current.action, current.targetType) }}</div>
        <div class="item">修改时间：{{ time(current.occurredAt) }}</div>
        <div v-if="current.remark" class="item">说明：{{ current.remark }}</div>
        <el-row>
          <el-col :span="12"><div class="grid-content"><div class="title">变更前</div><div v-for="item in side('before')" :key="item.key" class="item">{{ item.label }}：{{ item.value }}</div></div></el-col>
          <el-col :span="12"><div class="grid-content log-line"><div class="title">变更后</div><div v-for="item in side('after')" :key="item.key" class="item">{{ item.label }}：{{ item.value }}</div></div></el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from '@/api/live/intentDeposit'
import Pagination from '@/components/Pagination'
import { intentRows, intentTime, intentAction } from '@/utils/intent-deposit'
const FIELDS = [['configName', '配置名称'], ['productName', '商品名称'], ['amount', '金额'], ['validDays', '有效天数'], ['meetingDays', '专题课天数'], ['joinDays', '加盟天数'], ['saleStartAt', '售卖开始'], ['saleEndAt', '售卖结束'], ['enabled', '状态'], ['imgUrl', '商品封面'], ['description', '商品说明'], ['remark', '备注']]
export default {
  name: 'IntentDepositConfigLog', components: { Pagination },
  data() { return { logs: [], loading: false, error: '', query: { operatorName: '' }, dateTime: [], applied: { operatorName: '', range: [] }, pageNo: 1, pageSize: 10, current: null } },
  computed: {
    filtered() {
      const name = this.applied.operatorName.trim(), [start, end] = this.applied.range || []
      return this.logs.filter(row => (!name || String(row.operatorName || '').includes(name)) && (!start || this.time(row.occurredAt) >= start) && (!end || this.time(row.occurredAt) <= end))
    },
    pageRows() { return this.filtered.slice((this.pageNo - 1) * this.pageSize, this.pageNo * this.pageSize) }
  },
  created() { this.load() },
  methods: {
    time: intentTime, action: intentAction,
    async load() {
      const id = this.$route.query.id
      if (!/^[1-9]\d*$/.test(String(id))) { this.error = '缺少配置编号，请从意向金配置列表进入'; return }
      this.loading = true; this.error = ''
      try { const res = await api.configLogs(id); this.logs = intentRows(res.data) } catch (e) { this.error = e.message || '日志加载失败'; this.logs = [] } finally { this.loading = false }
    },
    search() { this.applied = { operatorName: this.query.operatorName || '', range: this.dateTime || [] }; this.pageNo = 1 },
    reset() { this.query.operatorName = ''; this.dateTime = []; this.search() },
    back() { window.history.go(-1) },
    value(value, key) {
      if (value === null || value === undefined || value === '') return '（空）'
      if (key === 'enabled' && typeof value === 'boolean') return value ? '启用' : '停用'
      return typeof value === 'object' ? JSON.stringify(value) : String(value)
    },
    // 有完整快照就按配置字段逐项列；老日志只记了字段变更或状态流转，就列这些
    side(which) {
      const row = this.current, snap = row[which]
      if (snap && typeof snap === 'object') return FIELDS.filter(([key]) => key in snap).map(([key, label]) => ({ key, label, value: this.value(snap[key], key) }))
      if (Array.isArray(row.changes) && row.changes.length) return row.changes.map((c, i) => ({ key: i, label: c.label || c.field, value: this.value(c[which], c.field) }))
      return [{ key: 'state', label: '状态', value: (which === 'before' ? row.beforeState : row.afterState) || '-' }]
    }
  }
}
</script>
